import { Share2 } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangChiTietDoiTac } from './pages/TrangChiTietDoiTac.js';
import { TrangFormDoiTac } from './pages/TrangFormDoiTac.js';
import { TrangImportSaoKe } from './pages/TrangImportSaoKe.js';
import { TrangNetwork } from './pages/TrangNetwork.js';

const networks: KhaiBaoModule = {
  id: 'networks',
  nav: {
    group: 'VẬN HÀNH',
    label: 'Network',
    icon: Share2,
    order: 3,
    permission: 'networks',
    to: '/network',
  },
  routes: [
    {
      path: '/network',
      element: createElement(TrangNetwork),
      permission: { module: 'networks', level: 'view' },
    },
    {
      path: '/network/moi',
      element: createElement(TrangFormDoiTac),
      permission: { module: 'networks', level: 'edit' },
    },
    {
      path: '/network/sao-ke/moi',
      element: createElement(TrangImportSaoKe),
      permission: { module: 'networks', level: 'edit' },
    },
    {
      path: '/network/:id',
      element: createElement(TrangChiTietDoiTac),
      permission: { module: 'networks', level: 'view' },
    },
    {
      path: '/network/:id/sua',
      element: createElement(TrangFormDoiTac),
      permission: { module: 'networks', level: 'edit' },
    },
  ],
};

export default networks;
